import { render, staticRenderFns } from "./Brigadas.vue?vue&type=template&id=8cd146c0&scoped=true"
import script from "./Brigadas.vue?vue&type=script&lang=js"
export * from "./Brigadas.vue?vue&type=script&lang=js"
import style0 from "./Brigadas.vue?vue&type=style&index=0&id=8cd146c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd146c0",
  null
  
)

export default component.exports